import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { ConsolidateAccountClient } from "../../../../../../Wrap/Api/Account/ConsolidateAccount";
import { AccountRoleDetailsClient } from "../../../../../../Wrap/Api/Customer/AccountRoleDetails";
import { CustomerUnderlyingAccountDetailsClient } from "../../../../../../Wrap/Api/Customer/CustomerUnderlyingAccountDetails";
import { UserAccountDisplaySettingsClient } from "../../../../../../Wrap/Api/User/UserAccountDisplaySettings";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ClientAccount } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { AccountRoleWithAccountDetails } from "../../../../../../Wrap/Models/Domains/Customers/AccountRoleWithAccountDetails";
import { UserAccountDisplaySettingModel } from "../../../../../../Wrap/Models/Domains/Users/UserAccountDisplaySettingModel";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import {
    PortfolioDashboardAccountRolesDisaptcher,
    PortfolioDashboardDisaptcher,
    PortfolioDashboardMultiSelectionDisaptcher,
} from "../Store/Variable";

export class PortfolioDashboardAction {
    public static getAllAccountsByCustomerId(customerId: number, callback?: (accounts: ClientAccount[]) => void) {
        const client = new CustomerUnderlyingAccountDetailsClient();
        const promise = client.get(customerId);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
            PortfolioDashboardDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });
        promise.onError((err) => {});
    }

    public static getAllAccountsByConsolidateAccountId(
        accontId: number,
        callback?: (accounts: ClientAccount[]) => void
    ) {
        const client = new ConsolidateAccountClient();
        const promise = client.get(HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Account, accontId));
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
            PortfolioDashboardDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });
        promise.onError((err) => {});
    }

    public static getMultiSelection(
        hierarchyId: string,
        allAccounts: ClientAccount[],
        callback?: (selections: string[]) => void
    ) {
        const client = new UserAccountDisplaySettingsClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((result) => {
            let selection = [];
            if (result.IsDefault) {
                allAccounts.forEach((account) => {
                    (account.SubAccounts || []).forEach((ele) => {
                        selection.push(ele.HierarchyId);
                    });
                });
            } else {
                selection = result.SelectedAccountHierarchyIds.filter((s) =>
                    allAccounts.some((a) => a.SubAccounts.some((sub) => HierarchyIdHelper.Equals(s, sub.HierarchyId)))
                );
                if (!selection.length && allAccounts.length) {
                    allAccounts.forEach((account) => {
                        (account.SubAccounts || []).forEach((ele) => {
                            selection.push(ele.HierarchyId);
                        });
                    });
                }
            }

            PortfolioDashboardMultiSelectionDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: selection,
            });
            if (callback) {
                callback(selection);
            }
        });
        promise.onError((err) => {});
    }

    public static resetMultiSelection() {
        PortfolioDashboardMultiSelectionDisaptcher.dispatch({
            actionType: ActionType.Success,
            payload: [],
        });
    }

    public static setMultiSelection(
        hierarchyId: string,
        selectedAccounts: string[],
        isDefault = false,
        callback?: (d: UserAccountDisplaySettingModel) => void
    ) {
        const selection = Array.from(new Set(selectedAccounts));
        const client = new UserAccountDisplaySettingsClient();
        const promise = client.put({
            IsDefault: isDefault,
            SelectedAccountHierarchyIds: selection,
            hierarchyId: hierarchyId,
        } as UserAccountDisplaySettingModel);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
            PortfolioDashboardMultiSelectionDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: selection,
            });
        });
        promise.onError((err) => {});
    }

    public static deleteSettings(callback?: (d: any) => void) {
        const client = new UserAccountDisplaySettingsClient();
        const promise = client.delete();
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
        promise.onError((err) => {});
    }

    public static getAccountRoleWithAccountDetails(
        customerId: number,
        callBack?: (val: AccountRoleWithAccountDetails) => void
    ) {
        const client = new AccountRoleDetailsClient();
        const promise = client.get(customerId);
        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
            PortfolioDashboardAccountRolesDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {});
    }
}
